const apiPrefix = '/'
const reSlashPrefix = /^\/+/

const resolveURL = (url: string) => {
  if (url.indexOf('http') === 0) {
    return url
  }
  if (url.charAt(0) !== '/') {
    return `${apiPrefix}/${url.replace(reSlashPrefix, '')}`
  }

  return url
}

const downloadFile = (url: string, obj?: any) => {
  const param: any = {
    url: resolveURL(url),
    obj: obj || {}
  }

  const form = document.createElement('form')
  form.action = param.url
  form.method = 'get'
  form.style.display = 'none'
  Object.keys(param.obj).forEach((key) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = param.obj[key]
    form.appendChild(input)
  })
  const button = document.createElement('input')
  button.type = 'submit'
  form.appendChild(button)
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

export default downloadFile
